export enum roles {
    eurofiscalis_admin = "eurofiscalis-admin",
    eurofiscalis_workers = "eurofiscalis-workers",
    api_eurofiscalis_workers_config = "api-eurofiscalis-workers-config",
    eurofiscalis_workers_admin = "eurofiscalis-workers-admin"
}